import React, { Component } from "react";
import { CustomCheckbox, BlueBtn } from "components/Controls";
import { connect } from "react-redux";
import { selectOffer, nextStep } from "../../actions";
import { mergeRight } from "ramda";
import { OfferView } from "components/DataDisplay";
import PropTypes from "prop-types";
import { required } from "utils/validations";
import { Field, reduxForm } from "redux-form";
import { AnalyticAPI } from "api/analytic";
import { tokenSelector } from "containers/EmbeddableWidget/selectors";
import {
  appRequestSelector,
  trendingsVisitID,
  subscribingDataSelector,
} from "../../selectors";
import { createStructuredSelector } from "reselect";
import OfferHeader from "../OfferHeader";
import { buildOfferData } from "containers/MultistepForm/helpers";
import { paymentFrequency } from "utils/helpers";

class FypnOffer extends Component {
  state = {
    loading: false,
    selectedOption: null,
  };

  componentDidMount = () => {
    const { offer } = this.props;
    if (offer.options && offer.options.length) {
      this.setSelected(offer.options[0]);
    }
  };

  setSelected = (option) => {
    const { offer, orderData } = this.props;

    option = mergeRight(option, {
      app_id: offer.app_id,
      provider: offer.provider,
      payment_schedule: offer.payment_schedule,
      approved_amount: offer.approved_amount,
      specific_provider_name: offer.provider,
      cart_total: orderData.total_price,
    });
    this.props.getSelectedOffer(option);
    this.setState({ selectedOption: option });
  };

  submitForm = () => {
    const { selectOffer, offer, logContinueEvent, token, visitID } = this.props;
    AnalyticAPI.send_provider_analytic_event(
      token,
      "select_provider",
      "fypn",
      visitID
    );
    logContinueEvent();
    this.setState({ loading: true });
    selectOffer({ selectedOffer: offer });
  };

  renderAgreementCheckbox = ({ input, meta }) => {
    return <CustomCheckbox meta={meta} {...input} />;
  };

  renderAgreement = () => {
    return (
      <div className="agreemnet-block">
        <div className="flex flex__align--center">
          <Field
            name="isAgreementFypnChecked"
            validate={[required]}
            component={this.renderAgreementCheckbox}
          />
          <div className="agreemnet-block__label">
            <span>
              I agree to the loan Terms and Conditions and Privacy Policy, and
              to receive SMS messages (including by auto-dialing system) to
              verify the mobile number I have provided. Message and data rates
              may apply.
            </span>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { loading, selectedOption } = this.state;
    const {
      handleSubmit,
      valid,
      available,
      isExpanded,
      offer,
      appRequest,
      toggleExpanded,
    } = this.props;

    if (!selectedOption) {
      return "";
    }

    return (
      <div className="expanded-block-component__expanded-content">
        <OfferHeader
          showPlanTypeTooltip
          available={available}
          isExpanded={isExpanded}
          dueToday={0}
          specificProviderName={offer.specific_provider_name}
          paymentPeriod={selectedOption.payment_period ? `${selectedOption.payment_period} Months` : ""}
          paymentFrequency={paymentFrequency(selectedOption)}
          approvedAmount={offer.approved_amount}
          typeOfPlan={selectedOption.type}
          toggleExpanded={toggleExpanded}
        />
        {isExpanded && (
          <form
            onSubmit={handleSubmit(this.submitForm)}
            className="fypn-offer application-offer"
          >
            <div className="step3__recommended-offer-plan offer-plan__top flex flex--wrap">
              <OfferView
                offerData={buildOfferData(
                  selectedOption,
                  {},
                  {},
                  appRequest.residenceInfo.state
                )}
              />
            </div>

            {this.renderAgreement()}

            <BlueBtn
              customClass="step3__recommended-content-btn"
              loading={loading}
              disabled={!available || !valid}
              type="submit"
            >
              Continue with Fypn
            </BlueBtn>
          </form>
        )}
      </div>
    );
  }
}

FypnOffer.propTypes = {
  offer: PropTypes.object.isRequired,
  available: PropTypes.bool,
};

FypnOffer.defaultProps = {
  available: true,
};

const mapStateToProps = createStructuredSelector({
  token: tokenSelector(),
  appRequest: appRequestSelector(),
  visitID: trendingsVisitID(),
  orderData: subscribingDataSelector(),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
    nextStep: (value) => dispatch(nextStep(value)),
  };
};

FypnOffer = connect(mapStateToProps, mapDistpatchToProps)(FypnOffer);

FypnOffer = reduxForm({
  form: "form",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(FypnOffer);

export default FypnOffer;
